import { Link as LinkIcon } from '@mui/icons-material'
import { Button } from '@mui/material'
import { useRef, useState } from 'react'
import type { SearchResultItem } from '@/features/search/types'
import { CopyLinkMenu } from '../../actions/CopyMenu'

type Props = {
  searchItem: SearchResultItem
}

export const CopyLinkAction = (props: Props) => {
  const ref = useRef(null)
  const [open, setOpen] = useState(false)
  const handleClose = () => setOpen(false)
  return (
    <>
      <Button
        ref={ref}
        title="Copy Media Link"
        onClick={() => {
          setOpen(true)
        }}
      >
        <LinkIcon />
      </Button>
      <CopyLinkMenu
        open={open}
        onClose={handleClose}
        anchorEl={ref.current}
        item={props.searchItem}
      />
    </>
  )
}
